import { ContentCard } from "@msuite/ui/content-card";
import { FileUpload, type FileUploadController } from "@msuite/ui/file-upload";
import { icon } from "@msuite/ui/icons";
import { FileCardRemote } from "@/components/files";

/** Props Interface */
interface ProtocolFormAttachmentsProps {
	controller: FileUploadController;
}

export function ProtocolFormAttachments({ controller }: ProtocolFormAttachmentsProps) {
	/** Render */
	return (
		<ContentCard
			icon={icon("Files")}
			title="Attachments"
			variant="plain"
			contentClassName="gap-4"
		>
			<FileUpload
				controller={controller}
				withLabel={false}
				renderFile={(file) => (
					<FileCardRemote
						fileId={file.id}
						onInteraction={async () => {}}
					/>
				)}
			/>
		</ContentCard>
	);
}
